module.exports = __webpack_public_path__ + "fee3c7435a68eb06338c1bf5c6cfba4c.svg";